import React from "react";
import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-social">
        <a href="https://facebook.com/dentalkaab" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
        <a href="https://instagram.com/dental.kaab" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
        <a href="https://wa.me/529848079667" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
      </div>
      <p>© 2025 Kaab Dental Experts · <a href="#">Aviso de privacidad</a></p>
    </footer>
  );
}
